import { useState } from 'react'
import { ShieldCheck, ChevronDown, ChevronUp, AlertTriangle, Flag } from 'lucide-react'
import { clsx } from 'clsx'
import { useAuthStore } from '@/store/useAuthStore'
import { useUIStore } from '@/store/uiStore'

export function SafetyTips() {
  const [isExpanded, setIsExpanded] = useState(false)
  const { isAuthenticated } = useAuthStore()
  const { openModal, showToast } = useUIStore()

  const handleReport = () => {
    if (!isAuthenticated) {
      openModal('login')
      return
    }
    // For now, show a toast - in future this could open a report modal
    showToast('Report feature coming soon. For urgent issues, contact support@isqroll.co.nz', 'info')
  }

  return (
    <div className="card border-l-4 border-l-amber-400">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 flex items-center justify-between text-left"
      >
        <div className="flex items-center gap-3">
          <ShieldCheck className="w-5 h-5 text-amber-500" />
          <span className="font-semibold">Safety Tips</span>
        </div>
        {isExpanded ? (
          <ChevronUp className="w-5 h-5 text-slate-400" />
        ) : (
          <ChevronDown className="w-5 h-5 text-slate-400" />
        )}
      </button>

      <div
        className={clsx(
          'overflow-hidden transition-all duration-200',
          isExpanded ? 'max-h-96' : 'max-h-0'
        )}
      >
        <div className="px-4 pb-4 space-y-3">
          <div className="flex items-start gap-3 text-sm text-slate-600">
            <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
            <span>Meet in a safe, public place for local pickups</span>
          </div>
          <div className="flex items-start gap-3 text-sm text-slate-600">
            <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
            <span>Never share personal or banking details until you trust the seller</span>
          </div>
          <div className="flex items-start gap-3 text-sm text-slate-600">
            <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
            <span>Inspect items before paying - if it seems too good to be true, it probably is</span>
          </div>
          <div className="flex items-start gap-3 text-sm text-slate-600">
            <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
            <span>Use secure payment methods and avoid cash deposits to strangers</span>
          </div>

          <hr className="my-3" />

          <button
            onClick={handleReport}
            className="flex items-center gap-2 text-sm text-red-600 hover:text-red-700"
          >
            <Flag className="w-4 h-4" />
            Report this listing
          </button>
        </div>
      </div>
    </div>
  )
}
